<template>
  <a-row :gutter="24" class="content-panle margin-0 padding-tb-0">
    <!-- 账户头像 -->
    <a-col :span="16" class="padding-tb-md">
      <h3 class="panle-head">{{ $t('userCenter.avatarTitle') }}</h3>

      <div class="ant-upload-preview" @click="$refs.modal.edit(1)">
        <div class="mask">
          <a-icon type="plus" />
        </div>

        <img v-if="userInfo&&userInfo.userLogoUrl" :src="userInfo.userLogoUrl" />
        <a-avatar v-else class="default-avatar" icon="user" />
      </div>
    </a-col>
    <!-- 账户信息 -->
    <a-form :form="form" @submit.prevent="handleChangeUserInfo">
      <a-col :span="16" class="padding-tb-md">
        <h3 class="panle-head">{{ $t('userCenter.accountInfoTitle') }}</h3>

        <!-- 组织名称 -->
        <a-col :span="24">
          <a-form-item :label="$t('userCenter.unitName')">
            <a-input
              :placeholder="$t('userCenter.unitName')"
              v-decorator="[
                'unitName',
                {
                  initialValue: userInfo.rootDeptName,
                  rules: [
                    { required: true, message: $t('userCenter.unitNameBlank') },
                    {
                      max: 40,
                      message: $t('userCenter.unitNameWarning'),
                      trigger: 'change'
                    }
                  ],
                  validateTrigger: 'blur'
                }
              ]"
            >
              <a-icon
                slot="prefix"
                type="bank"
                :style="{ color: 'rgba(0,0,0,.25)' }"
              />
            </a-input>
          </a-form-item>
        </a-col>
        <!-- 绑定的手机号 -->
        <a-col :span="24">
          <a-form-item :label="$t('userCenter.phone')">
            <a-input
              :placeholder="$t('userCenter.phone')"
              :value="userInfo.phone"
              disabled
            >
              <a-icon
                slot="prefix"
                type="mobile"
                :style="{ color: 'rgba(0,0,0,.25)' }"
              />
            </a-input>
          </a-form-item>
        </a-col>
        <!-- 修改绑定手机号 -->
        <a-col :span="24">
          <a-form-item :label="$t('userCenter.changePhone')">
            <a-input
              :placeholder="$t('userCenter.changePhoneTxt')"
              v-decorator="[
                'newMobile',
                {
                  rules: [
                    {
                      pattern: /^1[3456789]\d{9}$/,
                      message: $t('userCenter.changePhoneWarning')
                    }
                  ],
                  validateTrigger: 'blur'
                }
              ]"
            >
              <a-icon
                slot="prefix"
                type="mobile"
                :style="{ color: 'rgba(0,0,0,.25)' }"
              />
            </a-input>
          </a-form-item>
        </a-col>
        <!-- 手机验证码 -->
        <a-col :span="16">
          <a-form-item :label="$t('userCenter.varifyCode')">
            <a-input
              type="text"
              :placeholder="$t('userCenter.varifyCode')"
              :maxLength="6"
              v-decorator="[
                'verifyCode',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('userCenter.varifyCodeBlank')
                    }
                  ],
                  validateTrigger: 'blur'
                }
              ]"
            >
              <a-icon
                slot="prefix"
                type="mail"
                :style="{ color: 'rgba(0,0,0,.25)' }"
              />
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8" style="margin-top:44px">
          <a-button
            class="phone-verify-code-btn"
            :disabled="gettingVerifyCode"
            @click.stop.prevent="handleGetPhoneVerifyCode"
            v-text="
              (!gettingVerifyCode && $t('userCenter.varifyCodeBtn')) ||
                timeCountDown + ' s'
            "
          ></a-button>
        </a-col>

        <a-col :span="24" style="margin-top: 16px;">
          <a-button
            type="primary"
            html-type="submit"
            :disabled="btnSubmit"
            :loading="btnSubmit"
          >
            {{ $t('userCenter.submitAccountInfoBtn') }}
          </a-button>
        </a-col>
      </a-col>
    </a-form>

    <Verify
      @success="sendSuccess"
      :mode="'pop'"
      :captchaType="'blockPuzzle'"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="verify"
    ></Verify>
    <avatar-modal ref="modal" @ok="setavatar" />
  </a-row>
</template>

<script>
import Verify from '@/components/verifition/Verify'
import { mapActions, mapMutations, mapState } from 'vuex'
import AvatarModal from './AvatarModal'
import {
  modifyUserInfo,
  sendModifyPhoneCode,
  setUserConfig
} from '@/api/userMana'

export default {
  name: 'userCenterAccountSettings',
  components: {
    AvatarModal,
    Verify
  },
  data() {
    return {
      form: this.$form.createForm(this),

      gettingVerifyCode: false, // 是否已经点击‘获取验证码’
      timeCountDown: 60, // 获取手机验证码倒计时

      btnSubmit: false // 是否正在提交修改个人信息
    }
  },
  computed: {
    ...mapState(['userInfo', 'lang'])
  },
  created() {},
  activated() {},
  deactivated() {
    // this.form.resetFields()
  },
  methods: {
    ...mapMutations(['refreshUserInfo']),
    ...mapActions(['getOrgTreeSourceData']),

    // 设置头像 url
    async setavatar(url) {
      try {
        this.userInfo.userLogoUrl = url
        await setUserConfig({
          key: 'logoUrl',
          value: this.userInfo.userLogoUrl
        })
        this.refreshUserInfo(this.userInfo)
        this.$notification.success({
          message: this.$t('userCenter.setAvatarSuccess'),
          description: ''
        })
      } catch (error) {}
    },
    // 触发提交修改信息
    handleChangeUserInfo() {
      this.form.validateFields(async (err, values) => {
        // console.log('------handleChangeUserInfo-------', err, values)
        if (!err) {
          try {
            this.btnSubmit = true
            const res = await modifyUserInfo({
              newPhoneNumber: values.newMobile,
              rootDeptName: values.unitName,
              token: values.verifyCode
            })
            this.btnSubmit = false
            this.resetPhoneCode()
            this.form.setFieldsValue({ newMobile: '', verifyCode: '' })
            this.refreshUserInfo(res.data.collection[0])
            this.getOrgTreeSourceData()

            this.$notification.success({
              message: this.$t('userCenter.changeAccountInfoSuccess'),
              description: ''
            })
          } catch (error) {
            this.btnSubmit = false
          }
        }
      })
    },
    // 触发获取验证码
    async handleGetPhoneVerifyCode() {
      // 先验证手机号，再请求验证码
      this.form.validateFields(['newMobile'], { force: true }, async (err, values) => {
        console.log(values)
        if (!err) {
          if (!values.newMobile || !/^1[3456789]\d{9}$/.test(values.newMobile)){
            this.$notification.error({
              message: '新号码不正确',
              description: ''
            })
            return false
          }
          this.$refs.verify.show()
        }
      })
      // try {
      //   // 设置按钮禁用，且准备显示倒计时
      //   this.gettingVerifyCode = true
      //   // 开启倒计时
      //   this.interval = setInterval(() => {
      //     if (this.timeCountDown-- <= 0) this.resetPhoneCode()
      //   }, 1000)
      //   // 开启请求等待提示框
      //   this.waitingModal = this.$message.loading(
      //     this.$t('userCenter.varifyCodeSending'),
      //     0
      //   )
      //
      //   // 发送验证码请求
      //   await sendModifyPhoneCode({ userId: this.userInfo.id })
      //
      //   // 关闭请求等待提示框
      //   setTimeout(this.waitingModal, 1)
      //   this.$notification.success({
      //     message: this.$t('userCenter.varifyCodeSendSuccess'),
      //     description: ''
      //   })
      // } catch (error) {
      //   // 关闭请求等待提示框
      //   setTimeout(this.waitingModal, 1)
      //   this.resetPhoneCode()
      // }
    },
    // 重置发送手机验证码按钮
    resetPhoneCode() {
      // 关闭倒计时
      clearInterval(this.interval)
      // 重置倒计时时间
      this.timeCountDown = 60
      // 恢复请求手机验证码按钮状态
      this.gettingVerifyCode = false
    },

    //发送验证码
    sendSuccess(data){
      // 先验证手机号，再请求验证码
      this.form.validateFields(['newMobile'], { force: true }, async (err, values) => {
        console.log(err, values)
        if (!err) {
          try {
            let  param ={
                "browserInfo": "",
                "captchaFontSize": 0,
                "captchaFontType": "",
                "captchaId": "",
                "captchaOriginalPath": "",
                "captchaType": "blockPuzzle",
                "captchaVerification": data.captchaVerification,
                "clientUid": "",
                "jigsawImageBase64": "",
                "originalImageBase64": "",
                "point": {
                  "secretKey": "",
                  "x": 0,
                  "y": 0
                },
                "pointJson": "",
                "pointList": [{
                  "x": 0,
                  "y": 0
                }],
                "projectCode": "",
                "result": true,
                "secretKey": "",
                "token": "",
                "ts": 0,
                "wordList": []
              }
            // 发送验证码请求
            sendModifyPhoneCode(param).then(res=>{
              if (res && res.data.success){
                // 设置按钮禁用，且准备显示倒计时
                this.gettingVerifyCode = true;
                // 开启倒计时
                this.interval = setInterval(() => {
                  if (this.timeCountDown-- <= 0) this.resetPhoneCode()
                }, 1000);
                // 关闭请求等待提示框
                this.$notification.success({
                  message: this.$t('userRegister.varifyCodeSendSuccess'),
                  description: ''
                })
              }
            })
          } catch (error) {
            // 关闭请求等待提示框
            this.resetPhoneCode()
          }
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.main {
  width: 420px !important;
  margin-top: 32px;
}

.user-layout-change-password {
  h3 {
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: bold;
  }

  h3:before {
    content: '';
    margin-right: 10px;
    border: 2px solid #1890ff;
    border-radius: 5px;
  }

  .login {
    float: right;
    line-height: 40px;
  }
}

.avatar-upload-wrapper {
  height: 200px;
  width: 100%;
}

.ant-upload-preview {
  position: relative;
  margin: 36px;
  // margin-bottom: 36px;
  width: 100%;
  max-width: 180px;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;

  .upload-icon {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  .mask {
    z-index: 1;
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;

    &:hover {
      opacity: 1;
    }

    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }

  img,
  .mask {
    width: 100%;
    max-width: 180px;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
  }
  .default-avatar {
    width: 180px;
    height: 180px;
    font-size: 130px;
    padding: 20px;
    overflow: hidden;
  }
}
</style>
